import axiosInstance from "../../../api/axiosInstance";

export const fetchTournamentImagesAPI = async () => {
  const imagesList = await axiosInstance.get(
    "images/get-all-tournament-images"
  );

  return imagesList.data;
};

export const uploadTournamentImageAPI = async (imageData) => {
  const uploadedImage = await axiosInstance.post(
    "images/upload-image",
    imageData
  );

  return uploadedImage.data;
};

export const deleteTournamentImageAPI = async (id) => {
  const deleteImageId = await axiosInstance.delete(`images/delete-image/${id}`);

  return deleteImageId.data;
};
